import { Environment as SiteEnvironment } from '@sierralabs/core-ui';

import { Environment } from './environment.types';
import defaultEnvironment from './environment.default';

export const env: string = process.env.REACT_APP_CLIENT_ENV || 'development';
const environment: Partial<Environment> =
  require(`./environment.${env}`).default;
// merge default and loaded env into new object
const mergedEnvironment: Environment = Object.assign(
  {},
  defaultEnvironment,
  environment
);

// endpoints
// QMS (v1) -> /api
// platform-stack (v2) -> /api/v2

const environmentV1: Environment = mergedEnvironment;

export const environmentV2: SiteEnvironment = {
  ...mergedEnvironment,
  apiBaseUrl: mergedEnvironment.apiBaseUrl + 'v2/',
  entities: { task: 'TaskV2' }
};

export default environmentV1;
